module.exports = __webpack_public_path__ + "img/Ear_Rings.f47c95f2.jpg";